export const LOAD_LANDING_PARTICIPATING_RESOURCES_SUCCESS = 'load_landing_participating_resources_success';
export const LOAD_PARTICIPATING_RESOURCES_SEARCH_FILTERS_SUCCESS = 'load_participating_resources_search_filters_success';
export const LOAD_PARTICIPATING_RESOURCES_SEARCH_FILTERS_SELECTION_SUCCESS = 'load_participating_resources_search_filters_selection_success';
export const LOAD_PARTICIPATING_RESOURCES_SEARCH_RESULTS_SUCCESS = 'load_participating_resources_search_results_success';
export const ADD_PARTICIPATING_RESOURCES_SEARCH_RESULTS_SUCCESS = 'add_participating_resources_search_results_success';
export const CLICK_PARTICIPATING_RESOURCES_SEARCH_FILTER_SUCCESS = 'click_participating_resources_search_filter_success';
export const PARTICIPATING_RESOURCES_SWITCH_PAGE = 'participating_resources_switch_page';

export const LOAD_RESOURCES_LIST_SUCCESS = 'load_resources_list_success';
export const LOAD_SEARCH_RESULTS_SUCCESS = 'load_search_results_success';
export const UPDATE_RESOURCES_FILTER_SUCCESS = 'update_resources_filter_success';
export const RUN_FULL_TEXT_SEARCH = 'run_full_text_search';
export const SWITCH_SORTING = 'switch_sorting';
export const SWITCH_SORTING_ORDER = 'switch_sorting_order';
export const SWITCH_PAGE = 'switch_page';
export const PARTICIPATING_RESOURCES_SWITCH_SIZE = 'participating_resources_switch_size';
export const SWITCH_SIZE = 'switch_size';
export const SWITCH_VIEW = 'switch_view';
export const LOAD_DATASET_DETAIL_SUCCESS = 'load_dataset_detail_success';

export const RESOURCES_LOAD_RESOURCES_LIST_SUCCESS = 'resources_load_resources_list_success';
export const RESOURCES_LOAD_SEARCH_RESULTS_SUCCESS = 'resources_load_search_results_success';
export const RESOURCES_UPDATE_FILTER_SUCCESS = 'resources_update_filter_success';
export const RESOURCES_RUN_FULL_TEXT_SEARCH = 'resources_run_full_text_search';
export const RESOURCES_SWITCH_SORTING = 'resources_switch_sorting';
export const RESOURCES_SWITCH_SORTING_ORDER = 'resources_switch_sorting_order';
export const RESOURCES_SWITCH_PAGE = 'resources_switch_page';
export const RESOURCES_SWITCH_SIZE = 'resources_switch_size';

export const LOAD_DATARESOURCE_DETAIL_SUCCESS = 'load_dataresource_detail_success';
export const LOAD_DATARESOURCE_DETAIL_DATASETS_SUCCESS = 'load_dataresource_detail_datasets_success';

export const LOAD_DOCUMENT_SEARCH_RESULTS_SUCCESS = 'load_document_search_results_success';
export const PUT_SEARCH_KEYWORD = 'put_search_keyword';

export const LOAD_APPLICATION_VERSION_INFO_SUCCESS = 'load_application_version_info_success';
export const LOAD_WIDGET_UPDATE_SUCCESS = 'load_widget_update_success';
export const LOAD_SITE_UPDATE_SUCCESS = 'load_site_update_success';
export const ADD_SITE_UPDATE_SUCCESS = 'add_site_update_success';

export const LOAD_GLOSSARY_TERMS_SUCCESS = 'load_glossary_terms_success';
export const LOAD_GLOSSARY_BY_FIRST_LETTER_SUCCESS = 'load_glossary_by_first_letter_success';
export const LOAD_GLOSSARY_LETTERS_SUCCESS = 'load_glossary_letters_success';
